// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SpecialtiesRouteImport } from './routes/specialties'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ReviewHeallexaRouteImport } from './routes/review-heallexa'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PressRouteImport } from './routes/press'
import { Route as PostLoginRouteImport } from './routes/post-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as ListYourPracticeRouteImport } from './routes/list-your-practice'
import { Route as HelpRouteImport } from './routes/help'
import { Route as EditorRouteImport } from './routes/editor'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ClaimRouteImport } from './routes/claim'
import { Route as BrowseRouteImport } from './routes/browse'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InsuranceIndexRouteImport } from './routes/insurance.index'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ServicesServiceRouteImport } from './routes/services.$service'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as ProvidersIdRouteImport } from './routes/providers.$id'
import { Route as ProviderDashboardRouteImport } from './routes/provider.dashboard'
import { Route as ProviderSlugRouteImport } from './routes/provider.$slug'
import { Route as PatientDashboardRouteImport } from './routes/patient.dashboard'
import { Route as InsuranceSlugRouteImport } from './routes/insurance.$slug'
import { Route as ConditionsConditionRouteImport } from './routes/conditions.$condition'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as BlogCategoryRouteImport } from './routes/blog.$category'
import { Route as AuthMfaVerifyRouteImport } from './routes/auth.mfa-verify'
import { Route as AuthMfaSetupRouteImport } from './routes/auth.mfa-setup'
import { Route as AlternativesSplatRouteImport } from './routes/alternatives.$'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as SpecialtiesIndexRouteImport } from './routes/specialties.index'
import { Route as SpecialtiesSlugRouteImport } from './routes/specialties.$slug'
import { Route as PressIndexRouteImport } from './routes/press.index'
import { Route as PressZeroFeeAiDirectoryLaunchRouteImport } from './routes/press.zero-fee-ai-directory-launch'
import { Route as PressLaunch6mProvidersRouteImport } from './routes/press.launch-6m-providers'
import { Route as PressEndHealthcareBookingCrisisRouteImport } from './routes/press.end-healthcare-booking-crisis'
import { Route as PressDisruptDoctorDirectoriesRouteImport } from './routes/press.disrupt-doctor-directories'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as LoginProviderRouteImport } from './routes/login.provider'
import { Route as LoginPatientRouteImport } from './routes/login.patient'
import { Route as LoginAdminRouteImport } from './routes/login.admin'
import { Route as LocationsIndexRouteImport } from './routes/locations.index'
import { Route as LocationsStateRouteImport } from './routes/locations.$state'
import { Route as HelpSlugRouteImport } from './routes/help.$slug'
import { Route as DashboardPatientRouteImport } from './routes/dashboard.patient'
import { Route as DashboardNewListingRouteImport } from './routes/dashboard.new-listing'
import { Route as DashboardLifetimeSuccessRouteImport } from './routes/dashboard.lifetime-success'
import { Route as DashboardDoctorRouteImport } from './routes/dashboard.doctor'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard.calendar'
import { Route as DashboardAdminRouteImport } from './routes/dashboard.admin'
import { Route as LandingPagesDirectoryIndexRouteImport } from './routes/landing-pages.directory.index'
import { Route as DoctorsDirectoryIndexRouteImport } from './routes/doctors.directory.index'
import { Route as SpecialtySpecialtyCityRouteImport } from './routes/specialty.$specialty.$city'
import { Route as ProvidersIdClaimRouteImport } from './routes/providers_.$id.claim'
import { Route as ProvidersStateCityRouteImport } from './routes/providers.$state.$city'
import { Route as LandingPagesDirectoryPageRouteImport } from './routes/landing-pages.directory.$page'
import { Route as DoctorsDirectoryPageRouteImport } from './routes/doctors.directory.$page'
import { Route as BlogArticleSlugRouteImport } from './routes/blog.article.$slug'
import { Route as ApiAuthSplatRouteImport } from './routes/api.auth.$'
import { Route as ServicesServiceIndexRouteImport } from './routes/services.$service.index'
import { Route as ServicesServiceCitySlugRouteImport } from './routes/services.$service.$citySlug'
import { Route as InsuranceSlugIndexRouteImport } from './routes/insurance.$slug.index'
import { Route as InsuranceSlugCityRouteImport } from './routes/insurance.$slug.$city'
import { Route as ConditionsConditionIndexRouteImport } from './routes/conditions.$condition.index'
import { Route as ConditionsConditionCitySlugRouteImport } from './routes/conditions.$condition.$citySlug'
import { Route as LocationsStateIndexRouteImport } from './routes/locations.$state.index'
import { Route as LocationsStateCityRouteImport } from './routes/locations.$state.$city'
import { Route as DashboardDoctorProfileRouteImport } from './routes/dashboard.doctor_.profile'
import { Route as DashboardDoctorArchivedRouteImport } from './routes/dashboard.doctor_.archived'
import { Route as DashboardAdminReviewsRouteImport } from './routes/dashboard.admin.reviews'
import { Route as DashboardAdminRevenueYearlyRouteImport } from './routes/dashboard.admin.revenue-yearly'
import { Route as DashboardAdminRevenueSubscriptionsRouteImport } from './routes/dashboard.admin.revenue-subscriptions'
import { Route as DashboardAdminRevenueMonthlyRouteImport } from './routes/dashboard.admin.revenue-monthly'
import { Route as DashboardAdminRevenueFeaturedRouteImport } from './routes/dashboard.admin.revenue-featured'
import { Route as DashboardAdminRevenueCancellationsRouteImport } from './routes/dashboard.admin.revenue-cancellations'
import { Route as DashboardAdminRevenueRouteImport } from './routes/dashboard.admin.revenue'
import { Route as DashboardAdminRequestsRouteImport } from './routes/dashboard.admin.requests'
import { Route as DashboardAdminNotificationsRouteImport } from './routes/dashboard.admin.notifications'
import { Route as DashboardAdminListingsRouteImport } from './routes/dashboard.admin.listings'
import { Route as DashboardAdminLifetimeRouteImport } from './routes/dashboard.admin.lifetime'
import { Route as DashboardAdminDataQualityRouteImport } from './routes/dashboard.admin.data-quality'
import { Route as DashboardAdminClaimsRouteImport } from './routes/dashboard.admin.claims'
import { Route as DashboardAdminBulkImportsRouteImport } from './routes/dashboard.admin.bulk-imports'
import { Route as DashboardAdminBackupsRouteImport } from './routes/dashboard.admin.backups'
import { Route as DashboardAdminAvatarsRouteImport } from './routes/dashboard.admin.avatars'
import { Route as DashboardAdminAddListingsRouteImport } from './routes/dashboard.admin.add-listings'
import { Route as SpecialtySpecialtyStateStateRouteImport } from './routes/specialty.$specialty.state.$state'
import { Route as SpecialtySpecialtyDoctorsStateRouteImport } from './routes/specialty.$specialty.doctors.$state'
import { Route as ProvidersStateCitySpecialtyRouteImport } from './routes/providers.$state.$city_.$specialty'
import { Route as ApiPublicUpgradeTokenRouteImport } from './routes/api/public/upgrade.$token'
import { Route as ApiPublicHooksProcessUpgradeSequenceRouteImport } from './routes/api/public/hooks/process-upgrade-sequence'
import { Route as ApiPublicEmailUnsubscribeRouteImport } from './routes/api/public/email.unsubscribe'
import { Route as SpecialtySpecialtyCityTelehealthRouteImport } from './routes/specialty.$specialty.$city.telehealth'
import { Route as SpecialtySpecialtyCityAvailableTodayRouteImport } from './routes/specialty.$specialty.$city.available-today'
import { Route as SpecialtySpecialtyCityAcceptingNewPatientsRouteImport } from './routes/specialty.$specialty.$city.accepting-new-patients'
import { Route as ServicesServiceSpecialtyCitySlugRouteImport } from './routes/services.$service.$specialty.$citySlug'
import { Route as DashboardDoctorEditIdRouteImport } from './routes/dashboard.doctor_.edit.$id'
import { Route as DashboardAdminListingsAllRouteImport } from './routes/dashboard.admin.listings.all'
import { Route as SpecialtySpecialtyCityInsuranceAvailableTodayRouteImport } from './routes/specialty.$specialty.$city.$insurance.available-today'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SpecialtiesRoute = SpecialtiesRouteImport.update({
            id: '/specialties',path: '/specialties',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const ReviewHeallexaRoute = ReviewHeallexaRouteImport.update({
            id: '/review-heallexa',path: '/review-heallexa',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PostLoginRoute = PostLoginRouteImport.update({
            id: '/post-login',path: '/post-login',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LocationsRoute = LocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => rootRouteImport
          })
const ListYourPracticeRoute = ListYourPracticeRouteImport.update({
            id: '/list-your-practice',path: '/list-your-practice',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const EditorRoute = EditorRouteImport.update({
            id: '/editor',path: '/editor',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ClaimRoute = ClaimRouteImport.update({
            id: '/claim',path: '/claim',getParentRoute: () => rootRouteImport
          })
const BrowseRoute = BrowseRouteImport.update({
            id: '/browse',path: '/browse',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InsuranceIndexRoute = InsuranceIndexRouteImport.update({
            id: '/insurance/',path: '/insurance/',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ServicesServiceRoute = ServicesServiceRouteImport.update({
            id: '/services/$service',path: '/services/$service',getParentRoute: () => rootRouteImport
          })
const RTokenRoute = RTokenRouteImport.update({
            id: '/r/$token',path: '/r/$token',getParentRoute: () => rootRouteImport
          })
const ProvidersIdRoute = ProvidersIdRouteImport.update({
            id: '/providers/$id',path: '/providers/$id',getParentRoute: () => rootRouteImport
          })
const ProviderDashboardRoute = ProviderDashboardRouteImport.update({
            id: '/provider/dashboard',path: '/provider/dashboard',getParentRoute: () => rootRouteImport
          })
const ProviderSlugRoute = ProviderSlugRouteImport.update({
            id: '/provider/$slug',path: '/provider/$slug',getParentRoute: () => rootRouteImport
          })
const PatientDashboardRoute = PatientDashboardRouteImport.update({
            id: '/patient/dashboard',path: '/patient/dashboard',getParentRoute: () => rootRouteImport
          })
const InsuranceSlugRoute = InsuranceSlugRouteImport.update({
            id: '/insurance/$slug',path: '/insurance/$slug',getParentRoute: () => rootRouteImport
          })
const ConditionsConditionRoute = ConditionsConditionRouteImport.update({
            id: '/conditions/$condition',path: '/conditions/$condition',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const BlogCategoryRoute = BlogCategoryRouteImport.update({
            id: '/blog/$category',path: '/blog/$category',getParentRoute: () => rootRouteImport
          })
const AuthMfaVerifyRoute = AuthMfaVerifyRouteImport.update({
            id: '/auth/mfa-verify',path: '/auth/mfa-verify',getParentRoute: () => rootRouteImport
          })
const AuthMfaSetupRoute = AuthMfaSetupRouteImport.update({
            id: '/auth/mfa-setup',path: '/auth/mfa-setup',getParentRoute: () => rootRouteImport
          })
const AlternativesSplatRoute = AlternativesSplatRouteImport.update({
            id: '/alternatives/$',path: '/alternatives/$',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const SpecialtiesIndexRoute = SpecialtiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SpecialtiesRoute
          })
const SpecialtiesSlugRoute = SpecialtiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SpecialtiesRoute
          })
const PressIndexRoute = PressIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PressRoute
          })
const PressZeroFeeAiDirectoryLaunchRoute = PressZeroFeeAiDirectoryLaunchRouteImport.update({
            id: '/zero-fee-ai-directory-launch',path: '/zero-fee-ai-directory-launch',getParentRoute: () => PressRoute
          })
const PressLaunch6mProvidersRoute = PressLaunch6mProvidersRouteImport.update({
            id: '/launch-6m-providers',path: '/launch-6m-providers',getParentRoute: () => PressRoute
          })
const PressEndHealthcareBookingCrisisRoute = PressEndHealthcareBookingCrisisRouteImport.update({
            id: '/end-healthcare-booking-crisis',path: '/end-healthcare-booking-crisis',getParentRoute: () => PressRoute
          })
const PressDisruptDoctorDirectoriesRoute = PressDisruptDoctorDirectoriesRouteImport.update({
            id: '/disrupt-doctor-directories',path: '/disrupt-doctor-directories',getParentRoute: () => PressRoute
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LoginRoute
          })
const LoginProviderRoute = LoginProviderRouteImport.update({
            id: '/provider',path: '/provider',getParentRoute: () => LoginRoute
          })
const LoginPatientRoute = LoginPatientRouteImport.update({
            id: '/patient',path: '/patient',getParentRoute: () => LoginRoute
          })
const LoginAdminRoute = LoginAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => LoginRoute
          })
const LocationsIndexRoute = LocationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocationsRoute
          })
const LocationsStateRoute = LocationsStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => LocationsRoute
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => HelpRoute
          })
const DashboardPatientRoute = DashboardPatientRouteImport.update({
            id: '/patient',path: '/patient',getParentRoute: () => DashboardRoute
          })
const DashboardNewListingRoute = DashboardNewListingRouteImport.update({
            id: '/new-listing',path: '/new-listing',getParentRoute: () => DashboardRoute
          })
const DashboardLifetimeSuccessRoute = DashboardLifetimeSuccessRouteImport.update({
            id: '/lifetime-success',path: '/lifetime-success',getParentRoute: () => DashboardRoute
          })
const DashboardDoctorRoute = DashboardDoctorRouteImport.update({
            id: '/doctor',path: '/doctor',getParentRoute: () => DashboardRoute
          })
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => DashboardRoute
          })
const DashboardAdminRoute = DashboardAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => DashboardRoute
          })
const LandingPagesDirectoryIndexRoute = LandingPagesDirectoryIndexRouteImport.update({
            id: '/landing-pages/directory/',path: '/landing-pages/directory/',getParentRoute: () => rootRouteImport
          })
const DoctorsDirectoryIndexRoute = DoctorsDirectoryIndexRouteImport.update({
            id: '/doctors/directory/',path: '/doctors/directory/',getParentRoute: () => rootRouteImport
          })
const SpecialtySpecialtyCityRoute = SpecialtySpecialtyCityRouteImport.update({
            id: '/specialty/$specialty/$city',path: '/specialty/$specialty/$city',getParentRoute: () => rootRouteImport
          })
const ProvidersIdClaimRoute = ProvidersIdClaimRouteImport.update({
            id: '/providers_/$id/claim',path: '/providers/$id/claim',getParentRoute: () => rootRouteImport
          })
const ProvidersStateCityRoute = ProvidersStateCityRouteImport.update({
            id: '/providers/$state/$city',path: '/providers/$state/$city',getParentRoute: () => rootRouteImport
          })
const LandingPagesDirectoryPageRoute = LandingPagesDirectoryPageRouteImport.update({
            id: '/landing-pages/directory/$page',path: '/landing-pages/directory/$page',getParentRoute: () => rootRouteImport
          })
const DoctorsDirectoryPageRoute = DoctorsDirectoryPageRouteImport.update({
            id: '/doctors/directory/$page',path: '/doctors/directory/$page',getParentRoute: () => rootRouteImport
          })
const BlogArticleSlugRoute = BlogArticleSlugRouteImport.update({
            id: '/blog/article/$slug',path: '/blog/article/$slug',getParentRoute: () => rootRouteImport
          })
const ApiAuthSplatRoute = ApiAuthSplatRouteImport.update({
            id: '/api/auth/$',path: '/api/auth/$',getParentRoute: () => rootRouteImport
          })
const ServicesServiceIndexRoute = ServicesServiceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesServiceRoute
          })
const ServicesServiceCitySlugRoute = ServicesServiceCitySlugRouteImport.update({
            id: '/$citySlug',path: '/$citySlug',getParentRoute: () => ServicesServiceRoute
          })
const InsuranceSlugIndexRoute = InsuranceSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InsuranceSlugRoute
          })
const InsuranceSlugCityRoute = InsuranceSlugCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => InsuranceSlugRoute
          })
const ConditionsConditionIndexRoute = ConditionsConditionIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ConditionsConditionRoute
          })
const ConditionsConditionCitySlugRoute = ConditionsConditionCitySlugRouteImport.update({
            id: '/$citySlug',path: '/$citySlug',getParentRoute: () => ConditionsConditionRoute
          })
const LocationsStateIndexRoute = LocationsStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocationsStateRoute
          })
const LocationsStateCityRoute = LocationsStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => LocationsStateRoute
          })
const DashboardDoctorProfileRoute = DashboardDoctorProfileRouteImport.update({
            id: '/doctor_/profile',path: '/doctor/profile',getParentRoute: () => DashboardRoute
          })
const DashboardDoctorArchivedRoute = DashboardDoctorArchivedRouteImport.update({
            id: '/doctor_/archived',path: '/doctor/archived',getParentRoute: () => DashboardRoute
          })
const DashboardAdminReviewsRoute = DashboardAdminReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueYearlyRoute = DashboardAdminRevenueYearlyRouteImport.update({
            id: '/revenue-yearly',path: '/revenue-yearly',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueSubscriptionsRoute = DashboardAdminRevenueSubscriptionsRouteImport.update({
            id: '/revenue-subscriptions',path: '/revenue-subscriptions',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueMonthlyRoute = DashboardAdminRevenueMonthlyRouteImport.update({
            id: '/revenue-monthly',path: '/revenue-monthly',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueFeaturedRoute = DashboardAdminRevenueFeaturedRouteImport.update({
            id: '/revenue-featured',path: '/revenue-featured',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueCancellationsRoute = DashboardAdminRevenueCancellationsRouteImport.update({
            id: '/revenue-cancellations',path: '/revenue-cancellations',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRevenueRoute = DashboardAdminRevenueRouteImport.update({
            id: '/revenue',path: '/revenue',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminRequestsRoute = DashboardAdminRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminNotificationsRoute = DashboardAdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminListingsRoute = DashboardAdminListingsRouteImport.update({
            id: '/listings',path: '/listings',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminLifetimeRoute = DashboardAdminLifetimeRouteImport.update({
            id: '/lifetime',path: '/lifetime',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminDataQualityRoute = DashboardAdminDataQualityRouteImport.update({
            id: '/data-quality',path: '/data-quality',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminClaimsRoute = DashboardAdminClaimsRouteImport.update({
            id: '/claims',path: '/claims',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminBulkImportsRoute = DashboardAdminBulkImportsRouteImport.update({
            id: '/bulk-imports',path: '/bulk-imports',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminBackupsRoute = DashboardAdminBackupsRouteImport.update({
            id: '/backups',path: '/backups',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminAvatarsRoute = DashboardAdminAvatarsRouteImport.update({
            id: '/avatars',path: '/avatars',getParentRoute: () => DashboardAdminRoute
          })
const DashboardAdminAddListingsRoute = DashboardAdminAddListingsRouteImport.update({
            id: '/add-listings',path: '/add-listings',getParentRoute: () => DashboardAdminRoute
          })
const SpecialtySpecialtyStateStateRoute = SpecialtySpecialtyStateStateRouteImport.update({
            id: '/specialty/$specialty/state/$state',path: '/specialty/$specialty/state/$state',getParentRoute: () => rootRouteImport
          })
const SpecialtySpecialtyDoctorsStateRoute = SpecialtySpecialtyDoctorsStateRouteImport.update({
            id: '/specialty/$specialty/doctors/$state',path: '/specialty/$specialty/doctors/$state',getParentRoute: () => rootRouteImport
          })
const ProvidersStateCitySpecialtyRoute = ProvidersStateCitySpecialtyRouteImport.update({
            id: '/providers/$state/$city_/$specialty',path: '/providers/$state/$city/$specialty',getParentRoute: () => rootRouteImport
          })
const ApiPublicUpgradeTokenRoute = ApiPublicUpgradeTokenRouteImport.update({
            id: '/api/public/upgrade/$token',path: '/api/public/upgrade/$token',getParentRoute: () => rootRouteImport
          })
const ApiPublicHooksProcessUpgradeSequenceRoute = ApiPublicHooksProcessUpgradeSequenceRouteImport.update({
            id: '/api/public/hooks/process-upgrade-sequence',path: '/api/public/hooks/process-upgrade-sequence',getParentRoute: () => rootRouteImport
          })
const ApiPublicEmailUnsubscribeRoute = ApiPublicEmailUnsubscribeRouteImport.update({
            id: '/api/public/email/unsubscribe',path: '/api/public/email/unsubscribe',getParentRoute: () => rootRouteImport
          })
const SpecialtySpecialtyCityTelehealthRoute = SpecialtySpecialtyCityTelehealthRouteImport.update({
            id: '/telehealth',path: '/telehealth',getParentRoute: () => SpecialtySpecialtyCityRoute
          })
const SpecialtySpecialtyCityAvailableTodayRoute = SpecialtySpecialtyCityAvailableTodayRouteImport.update({
            id: '/available-today',path: '/available-today',getParentRoute: () => SpecialtySpecialtyCityRoute
          })
const SpecialtySpecialtyCityAcceptingNewPatientsRoute = SpecialtySpecialtyCityAcceptingNewPatientsRouteImport.update({
            id: '/accepting-new-patients',path: '/accepting-new-patients',getParentRoute: () => SpecialtySpecialtyCityRoute
          })
const ServicesServiceSpecialtyCitySlugRoute = ServicesServiceSpecialtyCitySlugRouteImport.update({
            id: '/$specialty/$citySlug',path: '/$specialty/$citySlug',getParentRoute: () => ServicesServiceRoute
          })
const DashboardDoctorEditIdRoute = DashboardDoctorEditIdRouteImport.update({
            id: '/doctor_/edit/$id',path: '/doctor/edit/$id',getParentRoute: () => DashboardRoute
          })
const DashboardAdminListingsAllRoute = DashboardAdminListingsAllRouteImport.update({
            id: '/all',path: '/all',getParentRoute: () => DashboardAdminListingsRoute
          })
const SpecialtySpecialtyCityInsuranceAvailableTodayRoute = SpecialtySpecialtyCityInsuranceAvailableTodayRouteImport.update({
            id: '/$insurance/available-today',path: '/$insurance/available-today',getParentRoute: () => SpecialtySpecialtyCityRoute
          })





const DashboardAdminListingsRouteChildren = {
  DashboardAdminListingsAllRoute: DashboardAdminListingsAllRoute
}

const DashboardAdminListingsRouteWithChildren = DashboardAdminListingsRoute._addFileChildren(DashboardAdminListingsRouteChildren)



const DashboardAdminRouteChildren = {
  DashboardAdminAddListingsRoute: DashboardAdminAddListingsRoute,DashboardAdminAvatarsRoute: DashboardAdminAvatarsRoute,DashboardAdminBackupsRoute: DashboardAdminBackupsRoute,DashboardAdminBulkImportsRoute: DashboardAdminBulkImportsRoute,DashboardAdminClaimsRoute: DashboardAdminClaimsRoute,DashboardAdminDataQualityRoute: DashboardAdminDataQualityRoute,DashboardAdminLifetimeRoute: DashboardAdminLifetimeRoute,DashboardAdminListingsRoute: DashboardAdminListingsRouteWithChildren,DashboardAdminNotificationsRoute: DashboardAdminNotificationsRoute,DashboardAdminRequestsRoute: DashboardAdminRequestsRoute,DashboardAdminRevenueRoute: DashboardAdminRevenueRoute,DashboardAdminRevenueCancellationsRoute: DashboardAdminRevenueCancellationsRoute,DashboardAdminRevenueFeaturedRoute: DashboardAdminRevenueFeaturedRoute,DashboardAdminRevenueMonthlyRoute: DashboardAdminRevenueMonthlyRoute,DashboardAdminRevenueSubscriptionsRoute: DashboardAdminRevenueSubscriptionsRoute,DashboardAdminRevenueYearlyRoute: DashboardAdminRevenueYearlyRoute,DashboardAdminReviewsRoute: DashboardAdminReviewsRoute
}

const DashboardAdminRouteWithChildren = DashboardAdminRoute._addFileChildren(DashboardAdminRouteChildren)



const DashboardRouteChildren = {
  DashboardAdminRoute: DashboardAdminRouteWithChildren,DashboardCalendarRoute: DashboardCalendarRoute,DashboardDoctorRoute: DashboardDoctorRoute,DashboardLifetimeSuccessRoute: DashboardLifetimeSuccessRoute,DashboardNewListingRoute: DashboardNewListingRoute,DashboardPatientRoute: DashboardPatientRoute,DashboardDoctorArchivedRoute: DashboardDoctorArchivedRoute,DashboardDoctorProfileRoute: DashboardDoctorProfileRoute,DashboardDoctorEditIdRoute: DashboardDoctorEditIdRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const HelpRouteChildren = {
  HelpSlugRoute: HelpSlugRoute
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)




const LocationsStateRouteChildren = {
  LocationsStateCityRoute: LocationsStateCityRoute,LocationsStateIndexRoute: LocationsStateIndexRoute
}

const LocationsStateRouteWithChildren = LocationsStateRoute._addFileChildren(LocationsStateRouteChildren)



const LocationsRouteChildren = {
  LocationsStateRoute: LocationsStateRouteWithChildren,LocationsIndexRoute: LocationsIndexRoute
}

const LocationsRouteWithChildren = LocationsRoute._addFileChildren(LocationsRouteChildren)




const LoginRouteChildren = {
  LoginAdminRoute: LoginAdminRoute,LoginPatientRoute: LoginPatientRoute,LoginProviderRoute: LoginProviderRoute,LoginIndexRoute: LoginIndexRoute
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)




const PressRouteChildren = {
  PressDisruptDoctorDirectoriesRoute: PressDisruptDoctorDirectoriesRoute,PressEndHealthcareBookingCrisisRoute: PressEndHealthcareBookingCrisisRoute,PressLaunch6mProvidersRoute: PressLaunch6mProvidersRoute,PressZeroFeeAiDirectoryLaunchRoute: PressZeroFeeAiDirectoryLaunchRoute,PressIndexRoute: PressIndexRoute
}

const PressRouteWithChildren = PressRoute._addFileChildren(PressRouteChildren)




const SpecialtiesRouteChildren = {
  SpecialtiesSlugRoute: SpecialtiesSlugRoute,SpecialtiesIndexRoute: SpecialtiesIndexRoute
}

const SpecialtiesRouteWithChildren = SpecialtiesRoute._addFileChildren(SpecialtiesRouteChildren)




const ConditionsConditionRouteChildren = {
  ConditionsConditionCitySlugRoute: ConditionsConditionCitySlugRoute,ConditionsConditionIndexRoute: ConditionsConditionIndexRoute
}

const ConditionsConditionRouteWithChildren = ConditionsConditionRoute._addFileChildren(ConditionsConditionRouteChildren)




const InsuranceSlugRouteChildren = {
  InsuranceSlugCityRoute: InsuranceSlugCityRoute,InsuranceSlugIndexRoute: InsuranceSlugIndexRoute
}

const InsuranceSlugRouteWithChildren = InsuranceSlugRoute._addFileChildren(InsuranceSlugRouteChildren)




const ServicesServiceRouteChildren = {
  ServicesServiceCitySlugRoute: ServicesServiceCitySlugRoute,ServicesServiceIndexRoute: ServicesServiceIndexRoute,ServicesServiceSpecialtyCitySlugRoute: ServicesServiceSpecialtyCitySlugRoute
}

const ServicesServiceRouteWithChildren = ServicesServiceRoute._addFileChildren(ServicesServiceRouteChildren)




const SpecialtySpecialtyCityRouteChildren = {
  SpecialtySpecialtyCityAcceptingNewPatientsRoute: SpecialtySpecialtyCityAcceptingNewPatientsRoute,SpecialtySpecialtyCityAvailableTodayRoute: SpecialtySpecialtyCityAvailableTodayRoute,SpecialtySpecialtyCityTelehealthRoute: SpecialtySpecialtyCityTelehealthRoute,SpecialtySpecialtyCityInsuranceAvailableTodayRoute: SpecialtySpecialtyCityInsuranceAvailableTodayRoute
}

const SpecialtySpecialtyCityRouteWithChildren = SpecialtySpecialtyCityRoute._addFileChildren(SpecialtySpecialtyCityRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AdminLoginRoute: AdminLoginRoute,BrowseRoute: BrowseRoute,ClaimRoute: ClaimRoute,DashboardRoute: DashboardRouteWithChildren,EditorRoute: EditorRoute,HelpRoute: HelpRouteWithChildren,ListYourPracticeRoute: ListYourPracticeRoute,LocationsRoute: LocationsRouteWithChildren,LoginRoute: LoginRouteWithChildren,PostLoginRoute: PostLoginRoute,PressRoute: PressRouteWithChildren,PrivacyRoute: PrivacyRoute,ReviewHeallexaRoute: ReviewHeallexaRoute,SearchRoute: SearchRoute,SignupRoute: SignupRoute,SitemapRoute: SitemapRoute,SpecialtiesRoute: SpecialtiesRouteWithChildren,TermsRoute: TermsRoute,AdminDashboardRoute: AdminDashboardRoute,AlternativesSplatRoute: AlternativesSplatRoute,AuthMfaSetupRoute: AuthMfaSetupRoute,AuthMfaVerifyRoute: AuthMfaVerifyRoute,BlogCategoryRoute: BlogCategoryRoute,CompareSlugRoute: CompareSlugRoute,ConditionsConditionRoute: ConditionsConditionRouteWithChildren,InsuranceSlugRoute: InsuranceSlugRouteWithChildren,PatientDashboardRoute: PatientDashboardRoute,ProviderSlugRoute: ProviderSlugRoute,ProviderDashboardRoute: ProviderDashboardRoute,ProvidersIdRoute: ProvidersIdRoute,RTokenRoute: RTokenRoute,ServicesServiceRoute: ServicesServiceRouteWithChildren,BlogIndexRoute: BlogIndexRoute,CompareIndexRoute: CompareIndexRoute,InsuranceIndexRoute: InsuranceIndexRoute,ApiAuthSplatRoute: ApiAuthSplatRoute,BlogArticleSlugRoute: BlogArticleSlugRoute,DoctorsDirectoryPageRoute: DoctorsDirectoryPageRoute,LandingPagesDirectoryPageRoute: LandingPagesDirectoryPageRoute,ProvidersStateCityRoute: ProvidersStateCityRoute,ProvidersIdClaimRoute: ProvidersIdClaimRoute,SpecialtySpecialtyCityRoute: SpecialtySpecialtyCityRouteWithChildren,DoctorsDirectoryIndexRoute: DoctorsDirectoryIndexRoute,LandingPagesDirectoryIndexRoute: LandingPagesDirectoryIndexRoute,ApiPublicEmailUnsubscribeRoute: ApiPublicEmailUnsubscribeRoute,ApiPublicHooksProcessUpgradeSequenceRoute: ApiPublicHooksProcessUpgradeSequenceRoute,ApiPublicUpgradeTokenRoute: ApiPublicUpgradeTokenRoute,ProvidersStateCitySpecialtyRoute: ProvidersStateCitySpecialtyRoute,SpecialtySpecialtyDoctorsStateRoute: SpecialtySpecialtyDoctorsStateRoute,SpecialtySpecialtyStateStateRoute: SpecialtySpecialtyStateStateRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)